import React, { useState, useEffect } from 'react';
import { Download, Clock, RefreshCw } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function LeadPullPage() {
  const [availableLeads, setAvailableLeads] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAuthHeader = () => ({
    'Authorization': `Bearer ${localStorage.getItem('admin_token')}`
  });

  useEffect(() => {
    fetchAvailableLeads();
  }, []);

  const fetchAvailableLeads = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/admin/leads/pull-eligible`,
        { headers: getAuthHeader() }
      );
      setAvailableLeads(response.data.leads || []);
    } catch (error) {
      console.error('Error fetching leads:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePullLead = async (leadId) => {
    try {
      await axios.post(
        `${BACKEND_URL}/api/admin/leads/${leadId}/pull`,
        {},
        { headers: getAuthHeader() }
      );
      alert('Lead pulled successfully!');
      fetchAvailableLeads();
    } catch (error) {
      console.error('Error pulling lead:', error);
      alert(error.response?.data?.detail || 'Failed to pull lead');
    }
  };

  return (
    <div className="lead-pull-container">
      <div className="page-header">
        <div>
          <h1><Download size={28} /> Lead Pull</h1>
          <p>Pull assigned but unattended leads</p>
        </div>
        <button className="btn-secondary" onClick={fetchAvailableLeads}>
          <RefreshCw size={16} /> Refresh
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : availableLeads.length === 0 ? (
        <div className="empty-state">
          <p>No leads available to pull</p>
        </div>
      ) : (
        <div className="leads-grid">
          {availableLeads.map(lead => (
            <div key={lead.id} className="pull-lead-card">
              <div className="pull-card-header">
                <h3>{lead.name}</h3>
                <span className="time-badge">
                  <Clock size={14} />
                  {Math.floor((Date.now() - new Date(lead.assigned_at)) / (1000 * 60 * 60))}h ago
                </span>
              </div>
              <div className="pull-card-body">
                <p><strong>Email:</strong> {lead.email}</p>
                <p><strong>Phone:</strong> {lead.phone}</p>
                <p><strong>Service:</strong> {lead.service_type}</p>
                <p><strong>Stage:</strong> {lead.stage}</p>
                <p><strong>Assigned to:</strong> {lead.assigned_to}</p>
              </div>
              <button 
                className="btn-primary"
                onClick={() => handlePullLead(lead.id)}
              >
                Pull This Lead
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
